import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import {FiveFTourInternalDashboardService, InternalTourData } from './fivef-tour-internal-dashboard.service';

@Component({
  selector: 'lohi-fivef-tour-internal-dashboard',
  templateUrl: './fivef-tour-internal-dashboard.component.html',
  styles: [
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FiveFTourInternalDashboardComponent implements OnInit {
  public internalTourData$: Observable<InternalTourData>;

  constructor(
    private internalDashboardServive: FiveFTourInternalDashboardService
  ) { }

  public ngOnInit(): void {
    this.internalTourData$ = this.internalDashboardServive.internalTourData$;
  }

}
